module.exports = "<button\n  md-effect\n  type=\"button\"\n  class=\"btn btn-sm btn-info\"\n  uib-tooltip=\"Enviar Credenciales al Correo\"\n  ng-click=\"$ctrl.reenviarCorreo()\"\n>\n  <i class=\"fa fa-share-square-o\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/usuarios/reenviar-confirmacion/reconfirmacion.html
// module id = 604
// module chunks = 0